import * as React from 'react'
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area'
import { cx } from 'class-variance-authority'

import './styles.css'

type ScrollAreaProps = {
  className?: string
  contentCn?: string
  scrollBarCn?: string
  noVerticalScroll?: boolean
  noHorizontalScroll?: boolean
  hideVerticalBar?: boolean
  hideHorizontalBar?: boolean
}

export const ScrollArea: React.ForwardRefExoticComponent<
  React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root> &
    React.RefAttributes<React.ElementRef<typeof ScrollAreaPrimitive.Root>> &
    ScrollAreaProps
> = React.forwardRef(
  (
    {
      className,
      contentCn,
      scrollBarCn,
      noVerticalScroll,
      noHorizontalScroll,
      hideVerticalBar,
      hideHorizontalBar,
      children,
      ...props
    },
    ref,
  ) => (
    <ScrollAreaPrimitive.Root
      className={cx('ScrollAreaRoot', className)}
      {...props}
    >
      <ScrollAreaPrimitive.Viewport ref={ref} className='ScrollAreaViewport'>
        <div className={cx('size-full', contentCn)}>{children}</div>
      </ScrollAreaPrimitive.Viewport>
      {!noVerticalScroll && (
        <ScrollAreaPrimitive.Scrollbar
          orientation='vertical'
          className={cx(
            'ScrollAreaScrollbar',
            { '!hidden': hideVerticalBar },
            scrollBarCn,
          )}
        >
          <ScrollAreaPrimitive.Thumb
            className={cx('ScrollAreaThumb', {
              '!hidden': hideVerticalBar,
            })}
          />
        </ScrollAreaPrimitive.Scrollbar>
      )}
      {!noHorizontalScroll && (
        <ScrollAreaPrimitive.Scrollbar
          orientation='horizontal'
          className={cx(
            'ScrollAreaScrollbar',
            {
              '!hidden': hideHorizontalBar,
            },
            scrollBarCn,
          )}
        >
          <ScrollAreaPrimitive.Thumb
            className={cx('ScrollAreaThumb', {
              '!hidden': hideVerticalBar,
            })}
          />
        </ScrollAreaPrimitive.Scrollbar>
      )}
      {!noVerticalScroll && !noHorizontalScroll && (
        <ScrollAreaPrimitive.Corner className='ScrollAreaCorner' />
      )}
    </ScrollAreaPrimitive.Root>
  ),
)

ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName
